// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__9qu79","dragIcon":"Choice_dragIcon__1JEdF","left":"Choice_left__fZ6ya","input":"Choice_input__zEMDC"};